import { reduce } from "et3-type-guards";

import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { MessageType } from "../../core/et3-table/UserCustomHelpers";
import { colors } from "../../core/et3-theme/colors";
import { TMessageReaction } from "../../Types";
import MessageReactions from "./index";

/**
 * The Message column of the three message tables: the message itself with the
 * live reactions and the history trigger underneath, as the design places them
 * inside the same cell rather than in a column of their own.
 */
const MessageWithReactionsCell = withLiteObserverAndTheme<{
  row: Record<string, any>;
}>((props) => {
  const { row } = props;
  const message = reduce(() => row.messageObject.message, "");
  const messageType = reduce(() => row.messageObject.messageType, "");

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      <MessageType message={message} messageType={messageType} />
      <MessageReactions
        messageId={reduce(() => row.messageId, -1)}
        messageSenderId={reduce(() => row.senderId, -1)}
        messageSenderGender={reduce(() => row.gender, "")}
        reactions={reduce(() => row.reactions, [] as TMessageReaction[])}
        hasReactionHistory={reduce(() => row.hasReactionHistory, false)}
      />
    </ET3Div>
  );
});
export default MessageWithReactionsCell;
